module.exports = __webpack_public_path__ + "static/media/react.cae7cc8a.jpg";